import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Category,CategoryService } from './category.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';


let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.product)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={selector: 'product-component',templateUrl: './pg/product/producthome.component.html'}
}
else
{
   componentdata={selector: 'product-component',template: '<div></div>'}

   
}
@Component(componentdata)

/*@Component({
    selector: 'product-component',
	//template: require('./producthome.component.html')
	templateUrl: './pg/product/producthome.component.html'
})*/

export class ProductHomeComponent implements OnInit {
	
	
	
	public serviceData;
	private _sub: Subscription;
	public headingtitle;
    public metadescription;
    public category;    
    public latestproducts:Array<any>;
    
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _pageService: CategoryService) {
		   
		   
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			//let slug =params['slug'];
			this.category='Product';
			
			

				 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			    let limit="4";
			    let compservice=document.querySelector('product-component');
			    if(compservice)
			    {
					if(compservice.getAttribute('limit'))
					{
						limit=compservice.getAttribute('limit');
					}
			    } 	
			   this._pageService.getlatestproduct(limit).subscribe(
        data => {
                 //     
                  //console.log(JSON.stringify(data.data));            
                  this.headingtitle=data.heading;          
                  this.latestproducts=data.product;
                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/product/producthome.component.ts